export default class legalTabs {
  constructor () {
    this.run()
  }
  run() {
    const legalTabSections = document.querySelectorAll('.legal_documents_section')
    if (legalTabSections) {
      Array.prototype.forEach.call(legalTabSections, (legalTabSection) => {
        const tabWrapper = legalTabSection.querySelector('.tabs-main-wrapper')
        const tabCards = tabWrapper.querySelectorAll('.tab-card')
        const tabContents = tabWrapper.querySelectorAll('.tab-wrapper')

        const yOffset = -50; 
        const scrollTarget = tabWrapper.querySelector('.tab-right-col')
        const y = scrollTarget.getBoundingClientRect().top + window.pageYOffset + yOffset;

        if (tabCards) {
          Array.prototype.forEach.call(tabCards, (tabCard) => {
            tabCard.addEventListener('click', () => {
              if (window.matchMedia('(max-width:992px)').matches) {
                window.scrollTo({top: y, behavior: 'smooth'});
              }
              //scrollTarget.scrollIntoView({block: 'start'})
              const tabIndex = tabCard.getAttribute('tabindex')
              Array.prototype.forEach.call(tabCards, (tabCard) => {
                tabCard.classList.remove('active')
              })
              Array.prototype.forEach.call(tabContents, (tabContent) => {
                const tabContentIndex = tabContent.getAttribute('tabindex')
                if (tabContentIndex === tabIndex) {
                  tabContent.classList.add('active')
                } else {
                  tabContent.classList.remove('active')
                }
              })
              tabCard.classList.add('active')
            })
          })
        }
      })
    }
  }
}